import { AnyAction } from "@nova/constants"
import {
    contextClearedAction,
    DecisionStatus,
} from "features/content-overlay/decision/decisionSlice"
import { DecisionEffectContext } from "features/content-overlay/decision/useDecisions"
import { enabledBackgroundCloseAction, resetOverlayAction } from "features/content-overlay/slice"
import { deleteHotspot } from "features/pubsub/entityActions/cubes/hotspot"
import { restoredFromSuspenseMemoryAction } from "panels/state/actions"

export const deleteHotspotDecisionId = "deleteHotspot"
export const deleteLayerDecisionId = "deleteLayer"

export enum Decision {
    Yes = "yes",
    No = "no",
}

const processDeleteHotspotDecision = (
    hotspotId: string,
    flightId: string,
    context: DecisionEffectContext
) => {
    const { lastDecision, dispatch } = context

    if (lastDecision === Decision.Yes) {
        // hide the overlay
        dispatch(restoredFromSuspenseMemoryAction())
        dispatch(resetOverlayAction())
        dispatch(deleteHotspot({ id: hotspotId, context: { flightId } }))
    }

    dispatch(enabledBackgroundCloseAction())
}

const processDeleteLayerDecision = (
    flightId: string,
    blurData: () => void,
    deleteFlight: ({ id }: { id: string }) => AnyAction,
    context: DecisionEffectContext
) => {
    const { lastDecision, dispatch } = context

    if (lastDecision === Decision.Yes) {
        blurData()
        dispatch(deleteFlight({ id: flightId }))
    }

    dispatch(enabledBackgroundCloseAction())
}

// note: you don't have to use the componentContext approach in simple case. but for us it helps to share more details
export const decisionProcessor =
    ({
        hotspotId,
        flightId,
        blurData,
        deleteFlight,
    }: {
        hotspotId?: string
        flightId: string
        blurData?: () => void
        deleteFlight?: ({ id }: { id: string }) => AnyAction
    }) =>
    // the decisionContext will contain the state details at the time the decision was made
    (decisionContext: DecisionEffectContext) => {
        const { decisionStatus, decisionId, dispatch } = decisionContext
        if (decisionStatus !== DecisionStatus.Decided) {
            return
        }
        switch (decisionId) {
            case deleteHotspotDecisionId:
                processDeleteHotspotDecision(hotspotId!, flightId, decisionContext)
                break
            case deleteLayerDecisionId:
                processDeleteLayerDecision(flightId, blurData!, deleteFlight!, decisionContext)
                break
            default:
                break
        }

        dispatch(contextClearedAction())
    }
